import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email'
import logo from '../assets/images/bludev-high-resolution-color-logo.jpeg';
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={logo} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="mailto:bludevllc@gmail.com"><EmailIcon/></a>
            <a href="https://www.linkedin.com/company/bludev-llc" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://github.com/fx-ha" target="_blank" rel="noreferrer"><GitHubIcon/></a>
          </div>
          <h1>BluDev</h1>
          <p>Web and Mobile Development</p>

          <div className="mobile_social_icons">
            <a href="mailto:admin@bludev.website"><EmailIcon/></a>
            <a href="https://www.linkedin.com/company/bludev-llc" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <a href="https://github.com/fx-ha" target="_blank" rel="noreferrer"><GitHubIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
